// @flow
/** @jsx jsx */

import { Text } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import PaymentMethodImage from '@zapier/payment/src/components/PaymentMethodImage';

import {
  paymentSourceMethods,
  type PaymentDetailsPaypal,
} from '@zapier/payment/src/types';
import { type Node } from 'react';

type ChildrenProps = {
  /** Paypal Payment source details */
  paypal: PaymentDetailsPaypal,
};

type Props = {
  ...$Exact<ChildrenProps>,
  children?: ChildrenProps => Node,
  /** Show compact version of info */
  isCompact?: boolean,
};

const detailsCss = {
  marginLeft: 15,
};

const wrapperCss = {
  alignItems: 'center',
  display: 'flex',
};

const renderDefaultInfo = ({ paypal }: ChildrenProps) => (
  <Text fontWeight={700} type="altText900">
    {paypal.email}
  </Text>
);

const renderCompactInfo = ({ paypal }: ChildrenProps) => (
  <Text color="grey500" type="altText900">
    {paypal.email}
  </Text>
);

const PaypalInfo = ({
  isCompact = false,
  children = isCompact ? renderCompactInfo : renderDefaultInfo,
  ...props
}: Props) => (
  <div css={wrapperCss}>
    <PaymentMethodImage
      imageType={paymentSourceMethods.paypal}
      isSmall={isCompact}
    />
    <div css={detailsCss}>{children(props)}</div>
  </div>
);

export default PaypalInfo;
